export default "__VITE_ASSET__C4DVzuMp__"